import React, {useEffect} from 'react';
import FlashMessages from './flashMessages.js';

// Interface for component props
interface SuccessfullAccountCreationProps {
    message: string;
}

export default function SuccessfullAccountCreation({message}: SuccessfullAccountCreationProps) {

    useEffect(() => {
        setTimeout(() => {
            window.location.reload();
        }, 
        2000);
    })

    return (<>
        <div>
            <br/>
            <br/>
            <div>
                <FlashMessages props={{
                    success_msg: message,
                    hideClose:true
                    }} />
            </div>
        </div>
    </>)
}

